<template>
    <div class="captcha-container">
        <canvas ref="captchaCanvas" width="160" height="60"></canvas>
        <button class="generate-captcha" type="button" @click="generateCaptcha">
            <!-- 刷新驗證碼 -->
            <img src="@/assets/refresh.svg" alt="Refresh Captcha" class="captcha-icon" />

            <!-- <i class="fas fa-sync-alt"></i> -->
        </button>
    </div>
</template>

<script>
export default {
    name: "CaptchaComponent",
    props: {
        length: { type: Number, default: 6 },
        digitsOnly: { type: Boolean, default: false },
    },
    data() {
        return {
            captchaCode: "",
        };
    },
    mounted() {
        this.generateCaptcha();
    },
    methods: {
        generateCaptcha() {
            const chars = this.digitsOnly
                ? '0123456789'
                : 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghjkmnpqrstuvwxyz23456789';
            let code = '';
            for (let i = 0; i < this.length; i++) {
                code += chars.charAt(Math.floor(Math.random() * chars.length));
            }
            this.captchaCode = code;
            this.drawCaptcha();
            this.$emit('update-captcha-code', this.captchaCode);
        },
        drawCaptcha() {
            const canvas = this.$refs.captchaCanvas;
            const ctx = canvas.getContext('2d');
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            ctx.fillStyle = '#f2f2f2';
            ctx.fillRect(0, 0, canvas.width, canvas.height);

            // Draw interference lines
            for (let i = 0; i < 5; i++) {
                ctx.strokeStyle = this.getRandomColor();
                ctx.beginPath();
                ctx.moveTo(Math.random() * canvas.width, Math.random() * canvas.height);
                ctx.lineTo(Math.random() * canvas.width, Math.random() * canvas.height);
                ctx.stroke();
            }

            // Draw interference dots
            for (let i = 0; i < 30; i++) {
                ctx.fillStyle = this.getRandomColor();
                ctx.beginPath();
                ctx.arc(Math.random() * canvas.width, Math.random() * canvas.height, 1, 0, Math.PI * 2);
                ctx.fill();
            }

            // Draw captcha text
            ctx.font = '24px Arial';
            ctx.fillStyle = '#000000';
            ctx.textBaseline = 'middle';
            const charSpacing = canvas.width / (this.captchaCode.length + 1);
            for (let i = 0; i < this.captchaCode.length; i++) {
                const char = this.captchaCode.charAt(i);
                const x = charSpacing * (i + 1);
                const y = canvas.height / 2;
                const angle = (Math.random() - 0.5) * 0.4;
                ctx.save();
                ctx.translate(x, y);
                ctx.rotate(angle);
                ctx.fillText(char, 0, 0);
                ctx.restore();
            }
        },
        getRandomColor() {
            const letters = '0123456789ABCDEF';
            let color = '#';
            for (let i = 0; i < 6; i++) {
                color += letters[Math.floor(Math.random() * 16)];
            }
            return color;
        },
    },
};
</script>

<style scoped>
.captcha-container {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.captcha-container canvas {
    border: 1px solid #ccc;
    margin-right: 10px;
}

.generate-captcha {

    padding: 8px 16px 8px 16px;
    border-radius:99px;


    background-color: white;
    border:none;

    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    margin-left:24px;

}

.generate-captcha:hover {
    /* background-color: #005f00; */
    background-color: #f2f2f2;
}


@media screen and (max-width: 560px) {

    /* 調整 CAPTCHA 容器 */
    .captcha-container {
        /* flex-direction: column; */
        align-items: center;
        margin-bottom: 10px;
    }

    .captcha-container canvas {
        margin-bottom: 0px;
        /* margin-right: 0; */
    }

    .generate-captcha {
        padding: 2.8px 2.24px 2.8px 2.24px;

    }

}
</style>